// extracted by mini-css-extract-plugin
module.exports = {"withCategory":"UCDRw","controls":"UPT4X","navbar":"_1yrg2","categoryName":"_3k5CZ","withSubcategories":"_9rX5A","breadcrumbArea":"_3jAFs"};